import { render, staticRenderFns } from "./ProjectDocumentAccessScope.vue?vue&type=template&id=5f963d7a"
import script from "./ProjectDocumentAccessScope.vue?vue&type=script&lang=ts"
export * from "./ProjectDocumentAccessScope.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f963d7a')) {
      api.createRecord('5f963d7a', component.options)
    } else {
      api.reload('5f963d7a', component.options)
    }
    module.hot.accept("./ProjectDocumentAccessScope.vue?vue&type=template&id=5f963d7a", function () {
      api.rerender('5f963d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/projects/ProjectDocumentAccessScope.vue"
export default component.exports